import map from '../map'
import Select from 'ol/interaction/Select';
import Toggle from 'ol-ext/control/Toggle';
import Overlay from 'ol-ext/control/Overlay';
import {get_species} from '../tele_funcs';
import './menu.css';

	// Overlays
	var menu = new Overlay ({ 
		closeBox : true, 
		className: "slide-left menu", 
		content: $("#menu").get(0)
	});
	map.addControl(menu);

//	var menu2= new Overlay ({ 
//		closeBox : true, 
//		className: "slide-right menu", 
//		content: $("#menu2").get(0)
//	});
//	map.addControl(menu2);

window.menu=menu;

// A toggle control to show/hide the menu
// Toggle needs to check if it's the same button that opened menu - if not then just change contents
//
//

var t = new Toggle( {	
	html: '<i class="fa fa-bars"></i>', //Uses font-awesome
	className: "dates",
	title: "Menu",
	onToggle: function() { 
	var sppcontent =($("<ul class='ol-spplegend'>"));
	var spp=get_species();
	if (window.species == null) window.species='igreylag';
	var current_spp=window.species;
	var sel;

	jQuery.each( spp, function( key, value ) {
		if(key==current_spp){
			sel=" class='selspp'";
		} else {
			sel='';
		}
		sppcontent.append( "<li"+sel+" id='"+key+"'><img src='img/goose_"+key+".jpg' width='45px'/>"+value+"</li>");
	});
		sppcontent.append( "</ul");
		sppcontent.append( "<div><b>Click a species to show tracks for it</b></div>");
	$("#menu p").html("Species being tracked");
	sppcontent=$(`<div id='sppdata' style='text-align:left;font-size:1em;'>`).append(sppcontent);

//	menu.toggle(); 

var tabarray=[
     { 'id':'tabs-1','title':'Species','content':sppcontent.prop('outerHTML')}
    
    ,{'id':'tabs-2','title':'Date','content':`
<div style='border:thin gray solid;'><b>Change the range of dates to show.</b> </br>
	<div>Start Date: </div>
	<div><input id='startdate' type='text' value='`+window.startdate+`'></div>
	<br/>
	<div>End Date:</div>
	<div><input id='enddate' type='text' value='`+window.enddate+`'><br/></div>
	<br/>
	<div>Detail  :  
		<br>
		<div style='border:thin gray solid;'>
			<b>Change how many fixes are shown.</b>
			<br/> 
			N.B. using the highest setting may make the map unresponsive if too many fixes are shown.  
		<input id='detail' readonly type='text'  style='display:none;border:0; color:#f6931f; font-weight:bold;' value='`+window.detail+`'> <br/>
		<div>
			<div style='float:left;'>High</div>
			<div style='float:right;'>Low</div>
		</div> 
		<br/>
		<br/>
		<div id='slider'></div>
		<br/>
	</div>
	</div>
	<input type='button' id='chnge' value='Apply Changes' >
</div>
`}
    
	,{ 'id':'tabs-3','title':'Animate a track','content':`<p>Animate tracks.</p>
	<input type="button" id="animate" value="Animate" >
	<br/>
	<label for="step_slider">Animation step (mins)</label>
	<input id='step_slider' readonly type='text'  style='border:0; color:#f6931f; font-weight:bold;' value='`+window.anim_step+`'>
	<br/>
	<div id="anim_step"></div>

	<label for="speed_slider">Animation frame rate (frames per minute)</label>
	<br/>
	<input id='speed_slider' readonly type='text'  style='border:0; color:#f6931f; font-weight:bold;' value='`+window.anim_speed+`'>
	<br/>
	<div id="anim_speed"></div>
		`}
];

if (
	window.location.href=="http://robin-nuc/goosetracks/admin.html" ||
	window.location.href=="http://robin-nuc/goosedevel/admin.html" ||
	window.location.href=="http://goosenews.org/goosedevel/admin.html" ||
	window.location.href=="https://goosenews.org/goosedevel/admin.html" || 
	window.location.href=="http://goosenews.org/goosetracks/admin.html" ||
	window.location.href=="https://goosenews.org/goosetracks/admin.html" 
){
var tabcontent = $(`
<div id="tabs"> 
  <ul>
    <li><a href="#tabs-1">`+tabarray[0].title+`</a></li>
    <li><a href="#tabs-2">`+tabarray[1].title+`</a></li>
    <li><a href="#tabs-3">`+tabarray[2].title+`</a></li>
  </ul>
	<div id="tabs-1">`+tabarray[0].content+`</div>
	<div id="tabs-2">`+tabarray[1].content+`</div>
	<div id="tabs-3">`+tabarray[2].content+`</div>
	<input type='button' id='showpartners' value='Show Partners' >
</div> `);
}
else{
var tabcontent = $(`
<div id="tabs"> 
  <ul>
    <li><a href="#tabs-1">`+tabarray[0].title+`</a></li>
    <li><a href="#tabs-2">`+tabarray[1].title+`</a></li>
  </ul>
	<div id="tabs-1">`+tabarray[0].content+`</div>
	<div id="tabs-2">`+tabarray[1].content+`</div>
	<input type='button' id='showpartners' value='Show Partners' >
</div> `);
}


//$("#menu").append(tabcontent);
$("#data").html(tabcontent);

var tabs= $( "#tabs" ).tabs({
//      event: "mouseover"   //Activates tab on hover
    });
    var previouslyFocused = false;
 
    tabs.find( ".ui-tabs-nav" ).sortable({
      axis: "x",

      // Sortable removes focus, so we need to restore it if the tab was focused
      // prior to sorting
      start: function(event, ui) {
        previouslyFocused = document.activeElement === ui.item[ 0 ];
      },
      stop: function(event, ui) {
        tabs.tabs( "refresh" );
        if (previouslyFocused) {
          ui.item.trigger( "focus" );
        }
      }
    });
$("#animate").off('click');
$("#animate").on('click',function(e,i){
	animate();
	menu.toggle();
});

$( "#anim_speed" ).slider({
      value:window.anim_speed,
      min: 10,
      max: 240,
      step: 10,
	value: 60,
      slide: function( event, ui ) {
        $( "#speed_slider" ).val( ui.value );
      }
    });
$( "#speed_slider" ).val(  $( "#anim_speed" ).slider( "value" ) );


$( "#anim_step" ).slider({
      value:window.anim_step,
      min: 5,
      max: 60,
      step: 5,
	value: 10,
      slide: function( event, ui ) {
        $( "#step_slider" ).val( ui.value );
      }
    });
$( "#step_slider" ).val(  $( "#anim_step" ).slider( "value" ) );

$("#showpartners").off('click');
$("#showpartners").on('click',function(e,i){
	//clear any fix info that may exist in this div
	//$(".data").html(""); 
	$(".sppdetails").html("");

	partners.toggle();
});
$(".data").off('click'); //reset any previous events assigned
$("#chnge").off('click');

$("#chnge").on('click',function(e,i){
	console.log("about to set window.startdate ",window.startdate);
	window.startdate=$('#startdate').val();
	console.log("just set window.startdate ",window.startdate);
	window.enddate=$('#enddate').val();
	window.detail=$('#detail').val();
	replaceSource();
	console.log('dddd',window.startdate,window.species,'Geese','plotgeojson');
});


	$( "#startdate" ).datepicker({ dateFormat: 'yy-mm-dd' });
	$( "#enddate" ).datepicker({ dateFormat: 'yy-mm-dd' });

    $( "#slider" ).slider({
      value:window.detail,
      min: 0,
      max: 100,
      step: 10,
      slide: function( event, ui ) {
        $( "#detail" ).val( ui.value );
      }
    });

$( "#detail" ).val(  $( "#slider" ).slider( "value" ) );
					menu.toggle(); 

// Events appear after the objects have been created


// Species events 

//	$("#chnge").off('click');

	$("#sppdata").off('click');

	$("#sppdata").on('click',function(e,i){
	//	alert(e.target.id);
		window.species=e.target.id;
		replaceSource();
	// Need to only do following if successful 

	//Find currently selected and toggle
		console.log(e.target.id,$(".selspp",e.target.parentNode).toggleClass("selspp"));
	//Toggle target element as selected
		e.target.id,e.target.classList.toggle('selspp');
	});

	}
});

map.addControl(t);
